module.exports = __webpack_public_path__ + "img/no-result-liked.24e27a49.png";